module.exports = __webpack_public_path__ + "img/ic_download_act_sen.af9b5cfb.svg";